import { Injectable } from '@angular/core';
import { SuperBatmanHeaderFactoryService } from 'src/app/shared/http/headers/super-batman-header-factory.service';
import { ContentTypeHeaderFactoryService } from 'src/app/shared/http/headers/content-type-header-factory.service';
import { HeaderArrayToHttpHeadersConversionService } from 'src/app/shared/http/headers/header-array-to-http-headers-conversion.service';
import { AuthorizationCodeRequestConfigurationService } from '../../../configuration/auth/authorization-code-request-configuration/authorization-code-request-configuration.service';

@Injectable({
  providedIn: 'root'
})
export class PKCEAuthorizationCodeRequestHeadersFactoryService {
  get authorizationCodeRequestConfiguration() {
    return this.authorizationCodeRequestConfigurationService.configuration;
  }

  get contentType() {
    return this.authorizationCodeRequestConfiguration.contentType;
  }

  constructor(private authorizationCodeRequestConfigurationService: AuthorizationCodeRequestConfigurationService,
    private contentTypeHeaderFactoryService: ContentTypeHeaderFactoryService,
    private superBatmanHeaderFactoryService: SuperBatmanHeaderFactoryService,
    private headerArrayToHttpHeadersConversionService: HeaderArrayToHttpHeadersConversionService) { }

  createHeaders() {
    const httpHeaderArray = this.createHeadersArray();
    return this.headerArrayToHttpHeaders(httpHeaderArray);
  }

  createContentTypeHeader() {
    return this.contentTypeHeaderFactoryService.createHeader(this.contentType);
  }

  createSuperBatmanHeader() {
    return this.superBatmanHeaderFactoryService.createHeader();
  }


  createHeadersArray() {
    const headerArray = [];
    const contentTypeHeader = this.createContentTypeHeader();
    headerArray.push(contentTypeHeader);
    return headerArray;
  }

  headerArrayToHttpHeaders(array) {
    return this.headerArrayToHttpHeadersConversionService.run(array);
  }
}
